
import axios from '../../http'
import { mapActions, mapGetters } from 'vuex'
import store from '../../config/store'

export default {

  components: {
    'component-dropdown': () => import(/* webpackChunkName: "components" */ '@/common/components/Dropdown.vue')
  },
  
  data: () => ({
    store,
    rates: [
      18,
      10,
      0,
      -1,
    ],
    vatRate: null,
    vatAmount: '',
    categories: []
  }),
  
  computed: {
    ...mapGetters([
      'operationCategories'
    ]),

    operation () {
      return store.sidepanel.dataModel
    },
    
    hasDocument () {
      return this.operation.documents.length
    },

    didDetailsOperationChange () {
      return this.operation.vat_rate !== this.vatRate || this.operation.vat_amount !== this.vatAmount || JSON.stringify(this.operation.categories) !== JSON.stringify(this.categories)
    },

    tooltipCategoriesLabel () {
      if (this.categories.length < 2) {
        return false
      }
      return this.categories.map(c => c.label + '<br>').join('')
    },

    dropdownCategoriesLabel () {
      if (!this.categories.length) return this.$i18n.t('form.select')
      if (this.categories.length === 1) return this.categories[0].label
      return this.categories.length + ' ' + this.$i18n.t('general.categories').toLowerCase()
    },
  },
  
  watch: {
    vatRate () {
      if (this.didDetailsOperationChange) {
        if (this.vatRate !== -1) {
          this.vatAmount = Math.round((this.operation.amount - (this.operation.amount / (1 + (this.vatRate) / 100))) * 100) / 100
          this.vatAmount = Math.round(this.vatAmount)
        } else {
          this.vatAmount = ''
        }
      }
    }
  },

  mounted () {
    this.categories = [ ...this.operation.categories ]
    this.vatRate = this.operation.vat_rate
    this.vatAmount = this.operation.vat_amount
  },
  
  methods: {
    ...mapActions([
      'addOperationCategory',
      'removeOperationCategory'
    ]),

    getRateLabel (rate) {
      if (rate === -1) {
        return 'Autre'
      }
      return `${rate} %`
    },

    addDocument (operation) {
      this.showModal({
        childVue: 'join-document',
        wrapperClass: 'modal modal--md',
        dataModel: operation
      })
    },

    saveOperation () {
      const vat = {
        vat_rate: this.vatRate,
        vat_amount: this.vatAmount,
        categories: this.categories
      }
      axios.put(`/operations/${this.operation.id}`, vat).then(() => {
        this.operation.vat_rate = this.vatRate
        this.operation.vat_amount = this.vatAmount
        this.operation.categories = [ ...this.categories ]
        this.hideSidePanel()
      })
    },

    onCategoriesSelected (value) {
      this.categories = value
    },

    onNewItemAdded (value) {
      if (value) {
        this.addOperationCategory(value).then(data => {
          this.categories.push(data)
        })
      }
    },

    onDeleteItem (id) {
      this.removeOperationCategory(id)
    },

    isTimestamp (value) {
      return !isNaN(value)
    }
  }
}
